module.exports = __webpack_public_path__ + "img/notFound_icon.32be94e2.png";